var React = require('react');

function JavascriptLogo (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Slice"),React.createElement("path",{"d":"M2 2h38v38H2V2zm9.992 31.756c.841 1.785 2.5 3.264 5.356 3.264 3.163 0 5.331-1.683 5.331-5.382V19.446h-3.57v12.142c0 1.785-.74 2.244-1.914 2.244-1.224 0-1.734-.842-2.295-1.836l-2.908 1.76zm12.627-.383c1.046 2.066 3.188 3.648 6.504 3.648 3.393 0 5.918-1.76 5.918-4.974 0-2.985-1.709-4.31-4.744-5.612l-.893-.382c-1.53-.664-2.194-1.098-2.194-2.169 0-.867.663-1.53 1.71-1.53 1.02 0 1.683.433 2.295 1.53l2.78-1.786c-1.173-2.066-2.805-2.857-5.076-2.857-3.188 0-5.229 2.041-5.229 4.72 0 2.907 1.71 4.285 4.286 5.381l.892.383c1.633.714 2.602 1.148 2.602 2.372 0 1.02-.943 1.76-2.423 1.76-1.76 0-2.755-.918-3.52-2.168l-2.908 1.684z","stroke":"#F6DF1D","fill":"none","fillRule":"evenodd","key":1})]);
}

JavascriptLogo.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42"};

module.exports = JavascriptLogo;

JavascriptLogo.default = JavascriptLogo;
